import { WarehouseDirectoryItem } from '@/console/api/types'
import { Tag } from '@/console/ui/Tag'

/**
 * LOGISPRD-15602 — 목록 행과 오른쪽 헤더가 같이 쓰는 상태 태그(활성 · LES 운영 · 누락 n).
 * LES 태그는 admin 모드에서만 — 활성 목록 폴백은 LES 를 조회하지 않아 모든 행이 `LES ?` 가 되면 잡음이다.
 */
const LesTag = ({ operating }: { operating: boolean | null }): JSX.Element => {
  if (operating === null) {
    return <Tag tone="neutral">LES ?</Tag>
  }
  return operating ? <Tag tone="neutral">LES 운영</Tag> : <Tag tone="warn">LES 미운영</Tag>
}

export const StatusTags = ({ item, showLes }: { item: WarehouseDirectoryItem; showLes: boolean }): JSX.Element => {
  const missingCount = item.missingAttributes?.length ?? 0
  return (
    <>
      {item.active ? <Tag tone="good">활성</Tag> : <Tag tone="neutral">비활성</Tag>}
      {showLes ? <LesTag operating={item.lesOperating} /> : null}
      {missingCount > 0 ? <Tag tone="warn">누락 {missingCount}</Tag> : null}
    </>
  )
}
